<div class="overlay {{lock? 'hidden':''}}">
  <div class="receipt open">
    <i class="armx-icon armx-cancel close-receipt" (click)="closeRecepit()"></i>
    <div class="containner">
      <div class="col-md-12">
        <div class="recipt-scanner">
          <div class="recipt-scanner-header">
            <div class="row">
              <div class="col-md-1">
                <img src="/assets/icons/payment.svg" style="max-width:50px;" />
              </div>
              <div class="col-md-11 title">
                <h4>{{ 'pages.createReceiptPage.generateCommercialInvoicePopup.title' | translate }}</h4>
              </div>
            </div>
          </div>
          <div class="recipt-scanner-body">
            <div class="row">
              <div class="col-md-4">
                <div class="form-group">
                  <label class="control-label">{{ 'common.invoiceNumber' | translate }}</label>
                  <input class="form-control" autocomplete="disabled" (blur)="checkError('invoiceNumber')"
                    [(ngModel)]="invoiceNumber" />
                  <span class="error-msg" *ngIf="getError('invoiceNumber')">
                    {{getError('invoiceNumber')}}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="control-label">{{ 'common.vatId' | translate }}</label>
                  <input class="form-control" autocomplete="disabled" (blur)="checkError('taxId')"
                    [(ngModel)]="taxId" />
                  <span class="error-msg" *ngIf="getError('taxId')">
                    {{getError('taxId')}}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-4">
                <div class="form-group dt-container">
                  <label class="control-label">{{ 'common.invoiceDate' | translate }}</label>
                  <input class="form-control" matInput [matDatepicker]="date" (blur)="checkError('invoiceDate')"
                    [(ngModel)]="invoiceDate" autocomplete="disabled" (focus)="date.open()" />
                  <mat-datepicker-toggle class="dt-toggle" matIconSuffix [for]="date"></mat-datepicker-toggle>
                  <mat-datepicker #date></mat-datepicker>
                  <span class="error-msg" *ngIf="getError('invoiceDate')">
                    {{getError('invoiceDate')}}
                  </span>
                </div>
              </div>
              <div class="col-md-4">
                <div class="form-group">
                  <label class="control-label">{{ 'common.reasonForExport' | translate }}</label>
                  <textarea class="form-control" (blur)="checkError('reasonForExport')" [(ngModel)]="reasonForExport"></textarea>
                  <span class="error-msg" *ngIf="getError('reasonForExport')">
                    {{getError('reasonForExport')}}
                  </span>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <commercial-details-items #commercialInvoice [invoiceItems]="invoiceItems" [receiptData]="receiptData"></commercial-details-items>
              </div>
            </div>
          </div>
          <div class="recipt-scanner-footer">
            <div class="row">
              <div class="col-md-12">
                <button class="btn btn-primary" style="float:right; margin-left: 10px;" (click)="onSaveClick()">{{ "common.save" | translate }}</button>
                <button class="btn btn-default" style="float:right" (click)="closeRecepit()">{{ "common.cancel" | translate }}</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>